/* istanbul ignore file */
// no idea of page height and scroll in jest
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
import throttle from "lodash.throttle";
/**
 * @param classname - element to check percent of is on screen
 * @param offset - sticky header size used to alter calculations
 * @param viewportHeight - current height of users screen
 * @returns object - contains idx of element with highest percent in view
 */
export var useSectionInScrollView = function (_a) {
    var classname = _a.classname, offset = _a.offset, loading = _a.loading, _b = _a.bottomOverlayHeight, bottomOverlayHeight = _b === void 0 ? 0 : _b;
    var _c = __read(useState({
        id: "",
        idx: 0,
    }), 2), activeNav = _c[0], setActiveNav = _c[1];
    var lastPosition = window.scrollY;
    useEffect(function () {
        var sections = document.querySelectorAll(".".concat(classname));
        /**
         * @param element - element to check percent of is on screen
         * @param scrollTop - current scroll of users browser
         * @param viewportHeight - current height of users screen
         * @returns number - percent of element that is in viewport
         */
        var getScreenPercent = function (_a) {
            var element = _a.element, scrollTop = _a.scrollTop, viewportHeight = _a.viewportHeight;
            var elementOffsetTop = element.offsetTop;
            var elementHeight = element.offsetHeight;
            var hiddenBefore = scrollTop + offset - elementOffsetTop;
            var hiddenAfter = elementOffsetTop + elementHeight - (scrollTop + viewportHeight);
            if (scrollTop > elementOffsetTop + elementHeight ||
                elementOffsetTop > scrollTop + viewportHeight) {
                return 0;
            }
            else {
                var result = 100;
                if (hiddenBefore > 0) {
                    result -= (hiddenBefore * 100) / elementHeight;
                }
                if (hiddenAfter > 0) {
                    result -= (hiddenAfter * 100) / elementHeight;
                }
                return result;
            }
        };
        /**
         * @returns void - sets idx of element with highest percent in view
         */
        var checkSections = function () {
            var _a;
            var viewportHeight = window.innerHeight - bottomOverlayHeight;
            var scrollTop = window.scrollY;
            var scrollDirection = "down";
            if (scrollTop < lastPosition) {
                scrollDirection = "up";
            }
            lastPosition = scrollTop;
            var totalScroll = scrollTop + viewportHeight + 30;
            var totalPageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
            // if user is at bottom of page set last component
            if (totalScroll > totalPageHeight) {
                return setActiveNav({
                    id: (_a = sections[sections.length - 1]) === null || _a === void 0 ? void 0 : _a.getAttribute("id"),
                    idx: sections.length - 1,
                });
            }
            else if (scrollTop < 20) {
                return setActiveNav({
                    id: sections[0].getAttribute("id"),
                    idx: 0,
                });
            }
            var highestPercent = {
                percent: 0,
                idx: 0,
                id: sections[0].getAttribute("id"),
            };
            sections.forEach(function (element, idx) {
                var percent = getScreenPercent({
                    element: element,
                    scrollTop: scrollTop,
                    viewportHeight: viewportHeight,
                });
                if (scrollDirection === "up") {
                    if (percent > highestPercent.percent) {
                        highestPercent = {
                            percent: percent,
                            idx: idx,
                            id: element.getAttribute("id"),
                        };
                    }
                }
                else {
                    if (percent >= highestPercent.percent) {
                        highestPercent = {
                            percent: percent,
                            idx: idx,
                            id: element.getAttribute("id"),
                        };
                    }
                }
            });
            setActiveNav({ id: highestPercent.id, idx: highestPercent.idx });
        };
        var throttledCheckSections = throttle(checkSections, 100);
        throttledCheckSections();
        window.addEventListener("scroll", throttledCheckSections);
        return function () {
            window.removeEventListener("scroll", throttledCheckSections);
        };
    }, [classname, offset, loading]);
    return { activeNav: activeNav };
};
